/**
 * Remove class helper method
 * @param {DOMelement} el - the element to remove a class from
 * @param {String} className - the class to remove
 * @return {DOMelement} el the original element
 */
const removeClass = (element, className) => {
  if (element === null) {
    return element;
  }

  element.classList.remove(className);
  return element;
};
export default removeClass;
